export enum SiteType {
  ServiceSite = 'Service Site',
  Subrecipient = 'Subrecipient',
}
